import type { MessagePayload } from "firebase/messaging";

export type FirebaseServiceWorkerMessage = {
  type: "FIREBASE_BACKGROUND_MESSAGE";
  payload: MessagePayload;
};

/**
 * Represents the expected shape before the service-worker message
 * is validated as FirebaseServiceWorkerMessage.
 */
export type TFirebaseServiceWorkerMessageData = {
  type: string;
  payload: object;
};

export type TServiceWorkerState = ServiceWorkerState | null;

export type TServiceWorker = ServiceWorker | null;

export type TFirebaseMessagingError = {
  name: string;
  message: string;
};

/**
 * Modes reported by the `app_control` Firestore document.
 */
export enum E_APP_CONTROL_MODE {
  NORMAL = "normal",
  VERSION_UPDATE = "version_update",
  MAINTENANCE = "maintenance"
}

/**
 * Validated/typed shape of the `app_control` Firestore document.
 */
export type TAppControl = {
  maintenanceStartsAtUnixMs: number;
  maintenanceEndsAtUnixMs: number;

  versionUpdateStartsAtUnixMs: number;
  versionUpdateEndsAtUnixMs: number;

  mode: E_APP_CONTROL_MODE;

  showWarningMessage: boolean;

  warningId: number;
  warningTitle: string;
  warningMessage: string;

  warningMessageStartsAtUnixMs: number;
  warningMessageEndsAtUnixMs: number;
};
